import { theme } from '@dojo/framework/core/middleware/theme';
import { create, w, v } from '@dojo/framework/core/vdom';
import { Icon } from '@holmescorp/base-widgets';

import css from '../css/editor.m.css';

interface IconButtonProperties {
	iconName: string;
	disabled?: boolean;
	title?: string;
	onClick?: () => void;
}

const factory = create({ theme }).properties<IconButtonProperties>();

export const IconButton = factory(({ middleware: { theme }, properties }) => {
	const { iconName: faname, disabled = false, title, onClick } = properties();

	const { iconButton } = theme.classes(css);
	return v(
		'button',
		{
			classes: [iconButton],
			disabled,
			title,
			onclick: (event) => {
				event.preventDefault;
				event.stopPropagation();
				onClick && onClick();
			}
		},
		[w(Icon, { faname, size: 'sm' })]
	);
});

export default IconButton;
